import { render, staticRenderFns } from "./dishDataCheck.vue?vue&type=template&id=1918111d&scoped=true&"
import script from "./dishDataCheck.vue?vue&type=script&lang=js&"
export * from "./dishDataCheck.vue?vue&type=script&lang=js&"
import style0 from "./dishDataCheck.vue?vue&type=style&index=0&id=1918111d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918111d",
  null
  
)

export default component.exports